const setLocalSettleAfterBill = (val) => {
  localStorage.setItem("settleAfterBill", val);
};
export default setLocalSettleAfterBill;
